import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ['container']

  connect() {
    this.timer = setInterval(this.countdown.bind(this), 1000)
    this.containerTarget.innerHTML = this.format(this.data.get('seconds'))
  }

  disconnect() {
    clearInterval(this.timer)
  }

  countdown() {
    let old_sec = this.data.get('seconds')
    let new_sec = old_sec - 1
    this.data.set('seconds', new_sec)
    this.containerTarget.innerHTML = this.format(new_sec)

    if (new_sec <= 0) {
      clearInterval(this.timer)
      window.location.reload()
    }
  }

  format(seconds) {
    let minute = Math.floor(seconds / 60);
    let sec = Math.floor(seconds % 60);
    let leading_sec = sec < 10 ? "0" : "";

    return minute + ":" + leading_sec + sec;
  }
}
